import { t, type I18nLocale } from '@ardoq/i18n';
import type { SimpleBlockDiagramLabels } from '@ardoq/simple-block-diagram';

export const getSimpleBlockDiagramLabels = (
  i18nLocale: I18nLocale
): SimpleBlockDiagramLabels => ({
  collapseAll: t(i18nLocale, 'simpleBlockDiagram:collapseAll', 'Collapse all'),
  expandAll: t(i18nLocale, 'simpleBlockDiagram:expandAll', 'Expand all'),
  zoomIn: t(i18nLocale, 'simpleBlockDiagram:zoomIn', 'Zoom in'),
  zoomOut: t(i18nLocale, 'simpleBlockDiagram:zoomOut', 'Zoom out'),
});
